import type { NodeInvitationToken, NodeInvitationTokenKind } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getInvitationToken } from '../services';
import { getInvitationTokenQueryKey } from './keys';

export type GetInvitationTokenQueryParams = {
  kind: NodeInvitationTokenKind;
  options?: Omit<
    UseQueryOptions<NodeInvitationToken, ApiClientResponseError<ResponseErrorDataObject>>,
    'queryFn' | 'queryKey'
  >;
  subjectId: string;
  subjectType: 'Event';
};

export const useGetInvitationTokenQuery = ({ kind, options, subjectId, subjectType }: GetInvitationTokenQueryParams) =>
  useQuery<NodeInvitationToken>({
    async queryFn() {
      const response = await getInvitationToken({ body: { kind, subjectId, subjectType } });

      return response.data;
    },
    queryKey: getInvitationTokenQueryKey({ kind, subjectId, subjectType }),
    ...options,
  });
